import { render, staticRenderFns } from "./card-produtos-detalhe.vue?vue&type=template&id=2c72cdd2&scoped=true"
import script from "./card-produtos-detalhe.vue?vue&type=script&lang=js"
export * from "./card-produtos-detalhe.vue?vue&type=script&lang=js"
import style0 from "./card-produtos-detalhe.vue?vue&type=style&index=0&id=2c72cdd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c72cdd2",
  null
  
)

export default component.exports